/**
 * 한글 초성 추출 유틸리티
 *
 * ContactTab 등에서 사용하는 한글 초성 분류 함수.
 */

/** 문자열 첫 글자에서 초성/영문 대문자/기타를 추출 */
export const getChoseong = (str: string): string => {
  if (!str) return '기타';
  const char = str.charAt(0);
  const charCode = char.charCodeAt(0) - 0xac00;
  if (charCode >= 0 && charCode <= 11172) {
    const list = ['ㄱ', 'ㄲ', 'ㄴ', 'ㄷ', 'ㄸ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅃ', 'ㅅ', 'ㅆ', 'ㅇ', 'ㅈ', 'ㅉ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'];
    return list[Math.floor(charCode / 588)];
  }
  if (/[a-zA-Z]/.test(char)) return char.toUpperCase();
  return '기타';
};
